import { Typography, styled } from '@mui/material';

export const ItalicHeading = styled(Typography)(({ theme }) => ({
  fontStyle: 'italic',
  fontSize: '1.5rem',
  fontWeight: 600,
  lineHeight: '2rem',
  color: theme.palette.primary.main,
}));
